import axios from 'axios';

// hfcapi rejects every call made with a session that no longer exists with
// 401 + this message (see verifyMiddlewares.js). Other 401s — e.g. a wrong old
// password on change-password — use different messages and must not log out.
const LOGGED_OUT_MESSAGE = 'Already logged out';

let redirecting = false;

// When the server says our session is gone, drop the stale login and do a full
// reload onto the login page. The full reload also guarantees the browser runs
// the latest deployed build of the app.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    const message = (response && response.data && response.data.message) || '';
    if (response && response.status === 401 && message.startsWith(LOGGED_OUT_MESSAGE)
      && localStorage.getItem('data') && !redirecting) {
      redirecting = true;
      localStorage.removeItem('data');
      window.location.replace('/');
    }
    return Promise.reject(error);
  },
);
